package org.vreo.devicehub.features.device.presentation.registerDevice

/**
 * Register device actions
 */
sealed interface RegisterDeviceActions {
    class OnClearError : RegisterDeviceActions
    data class OnRegisterDeviceClicked(val callback: (() -> Unit)? = null) : RegisterDeviceActions
    class OnBackNavigation : RegisterDeviceActions
    class OnUpdateSelectedProduct(val index: Int) : RegisterDeviceActions
    class OnUpdateSerialNumber(val value: String) : RegisterDeviceActions
    class OnUpdateAutoGenerateSerialNumber(val value: Boolean) : RegisterDeviceActions
    class OnUpdateDeviceIpAddress(val value: String) : RegisterDeviceActions
    class OnConnectToDeviceClicked() : RegisterDeviceActions
}